<template>
  <div>
    <payments-and-parts-filter :parts="bidParts"
                               :validations="$v.bidParts"
                               v-model="filteredParts"> </payments-and-parts-filter>
    <section v-maximizable>
      <div class="table-tab table-tab--th-row-none">
<!--      <div class="admin-buy__block-gui-btn a-flex-start u-margin-b-24">-->
<!--        <button class="gui-btn gui-btn&#45;&#45;red u-margin-left-auto" type="button" @click="onDownloadPaymentsClick">-->
<!--          {{$t('buttons.download-payments-table')}}-->
<!--        </button>-->
<!--        <file-picker :label="'buttons.upload-payments-table'"-->
<!--                     accept="csv"-->
<!--                     :signing="false"-->
<!--                     @prepared="onFileSelected"-->
<!--                     v-if="editable">-->
<!--        </file-picker>-->
<!--      </div>-->

      <template v-for="(part, partIdx) in parts">
      <div class="table-tab__container u-padding-bottom-12" style="overflow-x: auto">
        <table class="table-tab__block table" style="min-width: 1600px">
          <thead class="table-tab__thead">
            <tr class="">
            <th class="table-tab__border-bottom table-tab__th--row table-tab__border-right" colspan="2">{{$t('form.lot.payments.total')}}</th>

            <th class="table-tab__border-bottom" colspan="4">
            </th>

            <th class="table-tab__border-bottom">
              {{$t('form.lot.payments.date-of-fixing-price-in-contract-currency')}}
            </th>

            <th class="table-tab__border-bottom">
              {{$t('form.lot.payments.date-of-contract-signing-for-very-part')}}
            </th>

            <th class="table-tab__border-bottom">
              {{$t('form.lot.payments.delivery-time')}}
              <!-- меняется пользователем -->
            </th>

            <th class="table-tab__border-bottom">
              {{$t('form.lot.payments.delivery-date')}}
              <!--только текстовое поле part.deliveryDate-->
            </th>

            <th class="table-tab__border-bottom">
              {{$t('form.lot.payments.accepting-quality-date')}}
              <br>
              {{$t('form.lot.payments.accepting-segment-date')}}
              <!--только текстовое поле part.receiveDate-->
            </th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <tr>
              <th class="table-tab__th--row table-tab__border-bottom table-tab__border-right table-tab__btn-open text-nowrap" colspan="2">
<!--                <img src="@/assets/img/static/arrow-vector.png" alt="">-->
                <img class="table-tab__img-help"
                     src="@/assets/img/static/warning.svg"
                     v-if="wasPartChangedByParticipant(part.part)">
                <span class="u-padding-left-30">{{$t('form.lot.payments.total-part', {id: part.serial})}}</span>
              </th>

              <td class="table-tab__border-bottom" colspan="4">
              </td>

              <td class="font-italic table-tab__width-180 table-tab__border-bottom" style="font-size: 10px">
                {{$t('form.lot.will-be-automatically-determined-in-bid')}}
              </td>

              <td class="font-italic table-tab__width-180 table-tab__border-bottom" style="font-size: 10px">
                {{$t('form.lot.will-be-automatically-determined-in-bid')}}
              </td>

              <!-- delivery time (days) -->
              <td v-if="part.isEmpty">
                Не поставляется
              </td>
              <td v-else-if="editable && part.isDeliveryTimeRequired">
                <div class="a-form-field"
                     :class="{ 'a-input-group--error': $v.bidParts.$each[partIdx].deliveryTime.$anyError}">
                  <input type="text" class="a-input a-input--w-80"
                         v-model.number.lazy="part.deliveryTime"
                         @change="saveForm()">
                  <span class="" v-if="part.limits.deliveryTime.isFilled">
                    {{$t(part.limits.deliveryTime.precision.label)}} {{part.limits.deliveryTime.value}}
                  </span>
                </div>
              </td>
              <td class="font-weight-bolder" v-else>{{part.deliveryTime}}</td>

              <!-- delivery date -->
              <td v-if="part.isEmpty">
                Не поставляется
              </td>
              <td class="font-weight-bolder" v-else-if="part.initialDeliveryDate">
                <date-time :time="false" :value="part.initialDeliveryDate"></date-time>
              </td>
              <td v-else-if="part.isDeliveryDateRequired">
                <div class="a-form-field" :class="{ 'a-input-group--error': $v.bidParts.$each[partIdx].deliveryDatetime.$anyError}"  v-if="editable">
                  <date-picker v-model="part.deliveryDatetime"
                               @change="saveForm()"></date-picker>
                  <span class="a-validation-error"
                        v-if="!$v.bidParts.$each[partIdx].deliveryDatetime.validDate">
                      {{$t('form.lot.payments.not-earlier-than')}} <date-time tag="span" :value="lot.request.minimumDeliveryDate" :time="false"></date-time>
                    </span>
                </div>
                <date-time class="font-weight-bolder" :time="false" :value="part.deliveryDatetime" v-else></date-time>
              </td>
              <td v-else>
                Дата неопределена
              </td>

              <!-- accepting date -->
              <td v-if="part.isEmpty">
                Не поставляется
              </td>
              <td v-else-if="part.initialReceiveDate">
                <date-time class="font-weight-bolder" :time="false" :value="part.initialReceiveDate"></date-time>
              </td>
              <td v-else-if="part.isReceiveDateRequired">
                <div class="a-form-field" :class="{ 'a-input-group--error': $v.bidParts.$each[partIdx].receiveDatetime.$anyError}"  v-if="editable">
                  <date-picker v-model="part.receiveDatetime"
                               @change="saveForm()"
                               v-if="editable"></date-picker>
                  <span class="a-validation-error"
                        v-if="!$v.bidParts.$each[partIdx].receiveDatetime.validDate">
                      {{$t('form.lot.payments.not-earlier-than')}} <date-time tag="span" :value="part.deliveryDatetime" :placeholder="$t('form.lot.payments.delivery-date-placeholder')" :time="false"></date-time>
                    </span>
                </div>
                <date-time class="font-weight-bolder" :time="false" :value="part.receiveDatetime" v-else></date-time>
              </td>
              <td v-else>
                Дата неопределена
              </td>
            </tr>

            <tr>
              <td colspan="2" class="table-tab__border-bottom table-tab__border-right"></td>
              <td colspan="4" class="table-tab__border-bottom table-tab__border-right">
<!--                <span v-if="part.isEmpty">пустая</span>-->
                <bid-payments-pivot-table :bid="bid" :part="part.part"></bid-payments-pivot-table>
              </td>
              <td colspan="5" class="table-tab__border-bottom"></td>
            </tr>


            <tr class="table-tab__thead">
              <th></th>

              <th class="table-tab__th--row table-tab__border-right">
                {{$t('form.lot.payments.payment')}}
              </th>

<!--              <th class="table-tab__border-bottom">-->
<!--                {{$t('form.lot.payments.sum')}}-->
<!--              </th>-->
<!--              <th class="table-tab__border-bottom">-->
<!--                {{$t('form.lot.payments.bid-currency')}}-->
<!--              </th>-->
<!--              <th class="table-tab__border-bottom">-->
<!--                {{$t('form.lot.payments.contract-currency')}}-->
<!--              </th>-->
<!--              <th class="table-tab__border-bottom table-tab__border-right">-->
<!--                {{$t('form.lot.payments.currency-clause')}}-->
<!--              </th>-->
              <th colspan="4" class="able-tab__border-right"></th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.payment-deadline')}}
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.payment-size-in-percent')}}
              </th>

              <th class="table-tab__border-bottom">
                {{$t('form.lot.payments.date-of-fixing-price')}}
              </th>
              <th class="table-tab__border-bottom" colspan="2"></th>
            </tr>

            <template v-for="(payment, paymentIdx) in part.payments">
              <tr>
                <td class="table-tab__width-90"></td>

                <td class=" table-tab__th--row table-tab__border-right"
                    v-if="payment.type === 'contract'">
                  <img class="table-tab__img-help"
                       src="@/assets/img/static/warning.svg"
                       v-if="wasPaymentChangedByParticipant(part.part, payment.num, payment.payType)">
                  {{$t('form.lot.payments.prepayment')}} №{{payment.num}}
                  <br/>
                  <i><small>{{$t('form.lot.payments.from-date-of-contract-conclusion')}}</small></i>
                </td>
                <td class=" table-tab__th--row table-tab__border-right"
                    v-else-if="payment.type === 'delivery'">
                  <img class="table-tab__img-help"
                       src="@/assets/img/static/warning.svg"
                       v-if="wasPaymentChangedByParticipant(part.part, payment.num, payment.payType)">
                  {{$t('form.lot.payments.payment')}} №{{payment.num}}
                  <br/>
                  <i><small>{{$t('form.lot.payments.from-date-of-delivery-of-part')}}</small></i>
                </td>
                <td class=" table-tab__th--row table-tab__border-right"
                    v-else-if="payment.type === 'accept'">
                  <img class="table-tab__img-help"
                       src="@/assets/img/static/warning.svg"
                       v-if="wasPaymentChangedByParticipant(part.part, payment.num, payment.payType)">
                  {{$t('form.lot.payments.payment')}} №{{payment.num}}
                  <br/>
                  <i><small>{{$t('form.lot.payments.from-date-of-quality-accepting')}}</small></i>
                </td>

                <td colspan="4" class="font-italic table-tab__width-180 table-tab__border-right text-center" style="font-size: 10px">
                  <bid-payments-pivot-table :bid="bid" :part="part.part" :payment="payment"></bid-payments-pivot-table>
                </td>

                <td v-if="payment.isBlocked">
                  {{payment.blockedReason.valueOf() == enums.AdvancePaymentBlockReason.EMPTY_PART ? 'Не поставляется' : 'Запрещен'}}

                  <v-popover class="d-inline-block" placement="right" v-if="payment.blockedReason">
                    <img src="@/assets/img/static/info.svg">

                    <template slot="popover">
                      <span v-html="$t(payment.blockedReason.label)"></span>
                    </template>
                  </v-popover>
                </td>
                <td v-else-if="editable">
                  <div class="a-form-field" :class="{ 'a-input-group--error': isValidDuration(partIdx, paymentIdx)}">
                    <input type="text"
                           class="a-input a-input--w-80"
                           :disabled="payment.isDisabled"
                           :value="payment.duration"
                           @change="onPaymentFieldChange(payment, 'duration', +$event.target.value)">

                    <span class="a-validation-error" v-if="payment.limits.days.isFilled && isDurationInLimits(partIdx, paymentIdx)">
                      {{$t(getDaysLimitText(payment))}} {{payment.limits.days.value}}
                    </span>
                  </div>
                </td>
                <td v-else>{{payment.duration}}</td>

                <td v-if="payment.isBlocked">
                  {{payment.blockedReason.valueOf() == enums.AdvancePaymentBlockReason.EMPTY_PART ? 'Не поставляется' : 'Запрещен'}}

                  <v-popover class="d-inline-block" placement="right" v-if="payment.blockedReason">
                    <img src="@/assets/img/static/info.svg">

                    <template slot="popover">
                      <span v-html="$t(payment.blockedReason.label)"></span>
                    </template>
                  </v-popover>
                </td>
                <td v-else-if="editable">
                  <div class="a-form-field" :class="{ 'a-input-group--error': isValidPercent(partIdx, paymentIdx)}">
                    <input-percent class="a-input a-input--w-100"
                                   :value="payment.percent"
                                   :disabled="payment.isDisabled"
                                   @change="onPaymentFieldChange(payment, 'percent', +$event)">
                    </input-percent>
                    <span class="a-validation-error" v-if="payment.limits.percent.isFilled && isPercentInLimits(partIdx, paymentIdx)">
                      {{$t(getPercentLimitText(payment))}} {{payment.limits.percent.value|percent}}%
                    </span>
                  </div>
                </td>
                <td v-else>{{payment.percent|percent}}</td>

                <td>
                  <date-time :value="payment.commitDate" :time="false"></date-time>
                </td>

                <td>
                  <button class="gui-btn gui-btn--small gui-btn--red gui-btn--w-207"
                          @click.prevent="copyPayment(payment)"
                          v-if="editable && payment.copyTo && !payment.isBlocked">Применить к партиям с {{payment.copyTo[0]}} по {{payment.copyTo[payment.copyTo.length - 1]}}</button>
                </td>
              </tr>
            </template>

          </tbody>
        </table>
      </div>
      </template>
    </div>
    </section>

    <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST && bid.permissions.CAN_ADJUST_BID">
      <div class="a-container-form" >
        <button class="gui-btn gui-btn--red u-margin-left-auto"
                @click.prevent="onAllowBidUpdateClick">{{$t('buttons.grant-participant-editing')}}</button>
      </div>
      <approve-changes-dialog close-on-action
                              ref="approveChangesDialog"
                              :lot="lot"
                              :bid="bid"
                              section="Основные ценовые критерии"
      ></approve-changes-dialog>
    </template>
  </div>
</template>

<script>
  import { numeric, required } from '@/validators'
  import CommonMixins from '../mixins/common'
  import BidPaymentsPivotTable from "./BidPaymentsPivotTable";
  import PaymentsAndPartsFilter from "./PaymentsAndPartsFilter";
  import ApproveChangesDialog from "../../../common/dialogs/ApproveChangesDialog";

  export default {
    components: {
      ApproveChangesDialog,
      PaymentsAndPartsFilter,
      BidPaymentsPivotTable
    },

    props: {
      lot: Object,
      bid: Object
    },

    mixins: [
      CommonMixins
    ],

    data: () => ({
      filteredParts: [],
      saveWithError: true,
    }),

    computed: {
      bidParts() {
        return this.bid.parts;
      },

      parts() {
        return this.filteredParts;
      },

      editable() {
        return !!this.lot.request.permissions.HAS_ACCREDITATION && (this.bid.permissions.CAN_EDIT_BID || this.bid.isEditingForRetend);
      }
    },

    watch: {
      'bidParts': {
        immediate: true,
        deep: true,
        handler() {
          // if (this.bidParts.length != this.filteredParts.length) {
          //   this.filteredParts = [];
          // }
          this.$v.$touch();
        }
      }
    },

    validations: {
      adjustInfo: {
        description: {
          required
        },

        till: {
          date: {
            required
          },

          time: {
            required
          }
        }
      },

      bidParts: {
        $each: {
          deliveryTime: {
            validTime(value, part) {
              if (!part.isDeliveryTimeRequired || part.isEmpty) return true;

              if (!numeric(value)) {
                return false;
              }

              if (part.original && value > part.original.deliveryTime) {
                return false
              }

              if (part.limits.deliveryTime.isFilled) {
                if (part.limits.deliveryTime.precision.EXACTLY) {
                  return value === part.limits.deliveryTime.value;
                }

                if (part.limits.deliveryTime.precision.NOT_WORSE) {
                  return value > 0 && value <= part.limits.deliveryTime.value;
                }
              }

              return value > 0;
            }
          },

          deliveryDatetime: {
            validDate(value, part) {
              if (!part.isDeliveryDateRequired || part.initialDeliveryDate || part.isEmpty) return true;

              if (!value instanceof Date) {
                return false;
              }

              return part.deliveryDatetime >= this.lot.request.minimumDeliveryDate;
            }
          },

          receiveDatetime: {
            validDate(value, part) {
              if (!part.isDeliveryDateRequired || part.initialDeliveryDate || part.isEmpty) return true;

              if (!value instanceof Date) {
                return false;
              }

              return part.receiveDatetime >= part.deliveryDatetime;
            }
          },

          payments: {
            validPercent(items, part) {
              if (part.isEmpty) return true;

              const total = items.reduce((acc, e) => {
                return acc + (e.percent || 0);
              }, 0);

              return total === 10000;
            },

            $each: {
              duration: {
                inLimits(value, payment) {
                  if (payment.isBlocked) return true;

                  if (value === undefined) value = 0;

                  if (!numeric(value)) {
                    return false;
                  }

                  if (payment.limits.days.isFilled) {
                    if (payment.limits.days.precision.EXACTLY) {
                      return value === payment.limits.days.value;
                    }

                    if (payment.limits.days.precision.NOT_WORSE) {
                      return value >= payment.limits.days.value || (value == 0 && payment.percent == 0);
                    }
                  }

                  return true;
                },

                validDuration(value, payment) {
                  if (payment.isBlocked) return true;

                  if (value === undefined) value = 0;

                  if (!numeric(value)) {
                    return false;
                  }

                  if (payment.original && value < payment.original.duration) return false;

                  if (value == 0 && payment.percent || value < 0) return false;

                  return true;
                }
              },

              percent: {
                inLimits(value, payment) {
                  if (payment.isBlocked) return true;

                  if (value === undefined) value = 0;

                  if (!numeric(value)) {
                    return false;
                  }

                  if (payment.limits.percent.isFilled) {
                    if (payment.limits.percent.precision.EXACTLY) {
                      return value === payment.limits.percent.value;
                    }

                    if (payment.limits.percent.precision.NOT_WORSE) {
                      if (payment.type !== 'contract' && payment.type === payment.lastPayment.type && payment.num === payment.lastPayment.num) {
                        return value >= payment.limits.percent.value;
                      }
                      return value <= payment.limits.percent.value;
                    }
                  }

                  return true;
                },

                validPercent(value, payment) {
                  if (payment.isBlocked) return true;

                  if (value === undefined) value = 0;

                  if (!numeric(value)) {
                    return false;
                  }

                  if (payment.original && !payment.isEmptyCurrency) {
                    if (payment.type === 'contract' && value > payment.original.percent) {
                      return false;
                    }
                    else if (payment.type === 'accept' && payment.type === payment.lastPayment.type && payment.num === payment.lastPayment.num && value < payment.original.percent) {
                      return false;
                    }
                  }

                  if (value == 0 && payment.duration || value < 0) return false;

                  return true;
                }
              }
            }
          }
        }
      }
    },

    methods: {
      wasPartChangedByParticipant(part) {
        return !!_.find(this.lot.request.userChangesHistory, {
          bidNum: this.bid.num,
          part,
          payNum: 0
        });
      },

      wasPaymentChangedByParticipant(part, payment, type) {
        return !!_.find(this.lot.request.userChangesHistory, {
          bidNum: this.bid.num,
          part,
          payNum: payment,
          payType: type
        });
      },


      isDurationInLimits(partIndex, paymentIndex) {
        const field = this.$v.bidParts.$each[partIndex].payments.$each[paymentIndex].duration;
        return field.$dirty && !field.inLimits;
      },

      isValidDuration(partIndex, paymentIndex) {
        const field = this.$v.bidParts.$each[partIndex].payments.$each[paymentIndex].duration;
        return field.$anyError;
      },

      isPercentInLimits(partIndex, paymentIndex) {
        const field = this.$v.bidParts.$each[partIndex].payments.$each[paymentIndex].percent;
        return field.$dirty && !field.inLimits;
      },

      isValidPercent(partIndex, paymentIndex) {
        const field = this.$v.bidParts.$each[partIndex].payments.$each[paymentIndex].percent;
        const payments = this.$v.bidParts.$each[partIndex].payments;

        return field.$anyError || payments.$dirty && !payments.validPercent;
      },

      getDaysLimitText(payment) {
        if (payment.limits.days.precision.NOT_WORSE) {
          return 'precision.not-less';
        }

        return payment.limits.days.precision.label;
      },

      getPercentLimitText(payment) {
        if (payment.limits.percent.precision.NOT_WORSE) {
          if (payment.type !== 'contract' && payment.type === payment.lastPayment.type && payment.num === payment.lastPayment.num) {
            return 'precision.not-less';
          }
          return 'precision.not-more';
        }

        return payment.limits.percent.precision.label;
      },

      onAmountChanged(payment, part) {
        payment.percent = part.cost ? 10000 * payment.amount / part.cost: undefined;
      },

      async onPaymentFieldChange(payment, field, value) {
        payment[field] = value;

        await this.saveForm()
      },

      async copyPayment(payment) {
        _.map(payment.copyTo, partId => {
          if (partId === payment.part) return;

          const part = _.find(this.bidParts, {part: partId});
          if (part) {
            const p = _.find(part.payments, { num: payment.num, type: payment.type });

            if (p) {
              p.duration = payment.duration;
              p.percent = payment.percent;
            }
          }
        });

        await this.saveForm();
      },

      async onDownloadPaymentsClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('exportBidPayments', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              filename: `${this.lot.catalog.name}-${this.lot.request.id}-${this.bid.num}-payments`
            });
          }
          catch(e) {
            console.error('failed download of bid payments', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSelected(file) {
        try {
          await this.$store.dispatch('uploadBidPayments', {
            lotId: this.lot.id,
            requestId: this.lot.request.id,
            bidId: this.bid.id,
            file
          });

          await this.saveForm();
        }
        catch(e) {
          console.error('failed upload of bid payments', e);
          this.globalErrorHandler(e);
        }
      },

      onAllowBidUpdateClick() {
        this.$refs.approveChangesDialog.open({
          onConfirm: async (info) => {
            await this.onAllowBidUpdate(info);
          }
        })
      },

      async onAllowBidUpdate(adjustInfo) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('allowBidUpdate', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bid: this.bid.id,
              description: adjustInfo.description,
              till: adjustInfo.till
            });
          }
          catch(e) {
            console.error('failed allowing document update', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
